import { FIELD_VALUES } from './fieldValues';

export enum HYDRATION_STAGES {
  DRY = 'dry',
  HYDRATING = 'hydrating',
  HYDRATED = 'hydrated',
}

export enum LOAN_TYPE {
  BORROWING_POWER = 'borrowingPower',
  NEW_HOME_LOAN = 'newHomeLoan',
  REFINANCE = 'refinance',
}

export enum PAYMENT_TYPE {
  INTEREST_ONLY = 'Interest only',
  PRINCIPAL_AND_INTEREST = 'Principal and interest',
}

export enum TEAM_VIEW_URLS {
  APPLICATIONS = '/applications',
  NEW_APPLICATION = '/application/new/',
  EDIT_APPLICATION = '/application/:applicationId/edit/',
  APPLICANTS = '/application/:applicationId/applicants/',
  NEW_APPLICANT = '/application/:applicationId/applicant/new/',
  EDIT_APPLICANT = '/application/:applicationId/applicant/:applicantId/edit/',
  PROPERTIES = '/application/:applicationId/properties/',
  NEW_PROPERTY = '/application/:applicationId/property/new/',
  EDIT_PROPERTY = '/application/:applicationId/property/:propertyId/edit/',
}

export const APPLICATION_ID_PLACEHOLDER = 'applicationidplaceholder';

export const APPLICANT_ID_PLACEHOLDER = 'applicantidplaceholder';

export const NAVIGATION_AWAY_WARNING =
  'The data you entered will be lost. Please save to avoid losing any unsaved information.';

export const TEAM_VIEW_BASE_NAME = '/team-view';

export const APPLICATION_DEFAULT_NAME = 'Unnamed application';

export const DATE_FORMAT_DMY_KMS = 'DD/MM/YYYY, kk:mm:ss';

export const DATE_FORMAT_MY = 'MM/YYYY';

export const DATE_FORMAT_FULL_MONTH_YEAR = 'MMMM YYYY';

export const OTHER_OPTIONS = { label: 'Other', value: 'Other' };

export const NO_RELATIONSHIP = [FIELD_VALUES.SINGLE, FIELD_VALUES.DIVORCED, FIELD_VALUES.UNKNOWN];

export const RELATIONSHIP = [FIELD_VALUES.DE_FACTO, FIELD_VALUES.MARRIED];

export const READONLY_ALERT_HEADING = 'This application is locked.';

export const READONLY_ALERT_BODY =
  'No changes can be made to locked applications. To make changes, please contact your broker.';
